import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Belt-and-suspenders: swallow 401/403/404 unhandled Axios rejections.
// The primary fix is the window.addEventListener monkey-patch in public/index.html
// which wraps the webpack-dev-server overlay's own listener before it registers.
if (typeof window !== "undefined") {
  const onUnhandled = function(e) {
    const err = (e && (e.reason || e.error)) || e;
    const status = (err && err.response && err.response.status) || (err && err.status);
    const msg = (err && (err.message || String(err))) || "";
    if (
      status === 401 || status === 403 || status === 404 ||
      msg.includes("403") || msg.includes("401") || msg.includes("404")
    ) {
      if (e && e.stopImmediatePropagation) e.stopImmediatePropagation();
      if (e && e.stopPropagation) e.stopPropagation();
      if (e && e.preventDefault) e.preventDefault();
    }
  };
  window.addEventListener("unhandledrejection", onUnhandled, true);
  window.addEventListener("error", onUnhandled, true);
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
